var ChosenSelect = (function () {

  function init() {
    var config = {
      '.chosen-select': { search_contains: true, no_results_text: 'Поиск не дал результатов' },
      '.chosen-select-deselect': { search_contains: true, allow_single_deselect: true, no_results_text: 'Поиск не дал результатов' },
      '.chosen-select-no-single': { search_contains: true, disable_search_threshold: 10, no_results_text: 'Поиск не дал результатов' },
      '.chosen-select-no-results': { search_contains: true, no_results_text: 'Поиск не дал результатов' },
      '.chosen-select-width': { search_contains: true, width: "95% !important", no_results_text: 'Поиск не дал результатов' }
    }
    for (var selector in config) {
      $(selector).chosen(config[selector]);
    }
    $('.search-field').css({ width: '100%' });
    $('.search-field input').css({ width: '100%' });
  }

  return { Init: init}
}())
